import { render } from "./SelectBoxPage.vue?vue&type=template&id=f9d83636"
import script from "./SelectBoxPage.vue?vue&type=script&lang=js"
export * from "./SelectBoxPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__